import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useVillageWorkspacesAnalytics } from "./village-workspaces_analytics";
import { partnerConfig } from "./village-workspaces_partner_config";

const Theme = lazyWithRetry(() => import("./village-workspaces_theme"));

export function OfferingVillageWorkspacesListingMeetingRoom() {
  useVillageWorkspacesAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting rooms",
          description:
            "Whether you’re handling a conference video call or bringing your team in for an idea session, we have a multitude of stunning conference rooms that will be ideal for you. All are fitted with the best technology that allows you to focus more on doing your best and less about how to get that projector on.",
        }}
      />
    </Fragment>
  );
}
